import { useState } from 'react';
import { Text, Loader, Button, Flex } from '@vibe/core';
import { AppModal, AppModalContent } from '@gorilla/ui/src/components/AppModal';
import { Heading } from '@vibe/core';
import { getClientPortalUrl } from '../lib/utils';
import { monday } from '../services/monday';

type PublishModalProps = {
  mode: 'update' | 'publish';
  registryEntries: any;
  isPublishing: boolean;
  isOpen: boolean;
  onClose: () => void;
  publish: Function;
  portal: any;
  isSaving: boolean;
  setShowPreviewWindow: Function;
};

export function PublishModal({
  isPublishing,
  registryEntries,
  mode,
  isOpen,
  onClose,
  publish,
  portal,
  isSaving,
  setShowPreviewWindow,
}: PublishModalProps) {
  const [hasClickedPublish, setHasClickedPublish] = useState(false);
  const succeeded = hasClickedPublish && !isPublishing;

  return (
    <AppModal
      show={isOpen}
      onClose={() => {
        setHasClickedPublish(false);
        onClose();
      }}
      contentSpacing={false}
      alertDialog={true}
      width={320}
      id="publish__modal"
    >
      <AppModalContent>
        <div
          style={{
            marginTop: '16px',
            marginBottom: '32px',
          }}
        >
          <Flex justify="center" align="center" direction="column" gap={20}>
            <Flex justify="center" align="center" direction="column" gap={4}>
              <div
                style={{
                  overflow: 'hidden',
                  marginBottom: '16px',
                  borderRadius: '7px',
                  lineHeight: 0,
                }}
              >
                <img src="/clientportalbuilder_app_icon.png" width="40" height="40" alt="Client Portal Builder" />
              </div>
              {!succeeded ? (
                <Heading type="h3" weight="bold" align="center">
                  {mode === 'update' ? 'Update' : 'Publish'} Client Portal
                </Heading>
              ) : (
                <Heading type="h3" weight="bold" align="center">
                  Client Portal {mode === 'update' ? 'updated' : 'published'}
                </Heading>
              )}
              {!succeeded ? (
                <Text type="text2" align="center" color="secondary" element="p">
                  {mode === 'publish' ? <>Grant your clients access to the portal.</> : <>Apply the latest changes to your portal.</>}
                </Text>
              ) : (
                <Text type="text2" align="center" color="secondary" element="p">
                  Your configuration has been published.
                </Text>
              )}
            </Flex>

            {!hasClickedPublish && !isPublishing && !isSaving ? (
              <Flex gap={16}>
                <Button
                  kind="secondary"
                  size="medium"
                  color="inverted"
                  loading={isPublishing}
                  disabled={isPublishing}
                  onClick={() => {
                    setShowPreviewWindow(true);
                  }}
                  className="custom__publishbutton custom__publishbutton--secondary"
                >
                  Preview portal
                </Button>
                <Button
                  kind="primary"
                  size="medium"
                  color="inverted"
                  loading={isPublishing}
                  disabled={isPublishing}
                  onClick={() => {
                    setHasClickedPublish(true);
                    publish();
                  }}
                  className="custom__publishbutton"
                >
                  {mode === 'publish' ? 'Publish portal' : 'Publish portal'}
                </Button>
              </Flex>
            ) : null}

            {(hasClickedPublish && isPublishing) || isSaving ? (
              <div style={{ margin: '8px auto' }}>
                <Loader size={24} />
              </div>
            ) : null}

            {hasClickedPublish && !isPublishing && portal?.id ? (
              <Button
                kind="primary"
                size="medium"
                color="inverted"
                onClick={() => {
                  monday.execute('openLinkInTab', { url: getClientPortalUrl(portal?.id, registryEntries) });
                }}
                className="custom__publishbutton"
              >
                Open portal
              </Button>
            ) : null}
          </Flex>
        </div>
      </AppModalContent>
    </AppModal>
  );
}
